<script lang="ts">
  import { renderMarkdown } from "./markdown";
  import { navigateTo } from "../excel/api";

  interface Props {
    text: string;
  }

  let { text }: Props = $props();

  let renderedHtml = $state("");

  $effect(() => {
    renderMarkdown(text).then((html) => {
      renderedHtml = html;
    });
  });

  function parseCitationUri(href: string): { sheetId: number; range?: string } | null {
    if (!href.includes("#cite:")) return null;
    const path = href.split("#cite:")[1];
    if (!path) return null;
    const bangIdx = path.indexOf("!");
    if (bangIdx === -1) {
      const sheetId = parseInt(path, 10);
      return isNaN(sheetId) ? null : { sheetId };
    }
    const sheetId = parseInt(path.slice(0, bangIdx), 10);
    const range = path.slice(bangIdx + 1);
    return isNaN(sheetId) ? null : { sheetId, range };
  }

  function handleClick(e: MouseEvent) {
    const target = e.target as HTMLElement;
    const anchor = target.closest("a");
    if (!anchor) return;

    const href = anchor.getAttribute("href");
    if (!href) return;

    const citation = parseCitationUri(href);
    if (!citation) return;

    e.preventDefault();
    e.stopPropagation();
    navigateTo(citation.sheetId, citation.range).catch(console.error);
  }
  function linkInterceptor(node: HTMLElement) {
    node.addEventListener("click", handleClick);
    return {
      destroy() {
        node.removeEventListener("click", handleClick);
      }
    };
  }
</script>

<div class="markdown-content" use:linkInterceptor>
  {@html renderedHtml}
</div>

